import find from 'lodash/find';

import { ApiService } from './api.service';
import { CheckoutService } from './checkout.service';

export const ShopperAccountService = angular
    .module('checkout.shopperAccountService', [
        ApiService,
        CheckoutService
    ]).service('shopperAccountService', (checkoutService, apiService, $q) => {
        function applyAccountInfoToCart(shopperAccount, shippingAddress) {
            if (!shippingAddress || !shopperAccount) return $q.reject();
            return checkoutService.getAndUpdateCart((cart) => {
                const cartWithShippingAddress = applyShippingAddressToCartLogic(cart, shippingAddress);
                const cartWithContactAndShipping = applyContactInfoToCartLogic(cartWithShippingAddress, shopperAccount);
                return cartWithContactAndShipping;
            });
        }

        function applyShippingAddressToCart(shippingAddress) {
            if (!shippingAddress) return $q.reject();
            return checkoutService.getAndUpdateCart(cart => applyShippingAddressToCartLogic(cart, shippingAddress));
        }

        function applyContactInfoToCart(shopperAccount) {
            return checkoutService.getAndUpdateCart(cart => applyContactInfoToCartLogic(cart, shopperAccount));
        }

        function applyShippingAddressToCartLogic(cart, shippingAddress) {
            return {
                ...cart,
                shippingAddress: {
                    firstName: shippingAddress.address.firstName,
                    lastName: shippingAddress.address.lastName,
                    address1: shippingAddress.address.address1,
                    address2: shippingAddress.address.address2,
                    city: shippingAddress.address.city,
                    state: shippingAddress.address.state,
                    postalCode: shippingAddress.address.postalCode,
                    country: shippingAddress.address.country
                },
                selectedShippingAddressId: shippingAddress.id
            };
        }

        function applyContactInfoToCartLogic(cart, shopperAccount) {
            return {
                ...cart,
                contactInfo: {
                    email: shopperAccount.emailAddress,
                    phoneNumber: shopperAccount.phoneNumber
                },
                shopperId: shopperAccount.id
            };
        }

        function getAllShopperData() {
            return $q.all([
                apiService.account.get(),
                apiService.account.shippingAddress.getAll(),
                apiService.account.paymentMethod.getAll().catch((err) => {
                    if (err.status !== 400) { // stripe not connected
                        return $q.reject(err);
                    }
                })
            ]).then(([shopperAccount, shippingAddresses, paymentMethods]) => {
                return {
                    shopperAccount,
                    shippingAddresses,
                    paymentMethods
                };
            });
        }

        function getDefaultShippingAddress(shippingAddresses) {
            const defaultShippingAddress = find(shippingAddresses.items, 'address.isDefault');
            if (defaultShippingAddress) return defaultShippingAddress;

            if (shippingAddresses.items.length > 0) {
                return shippingAddresses.items[0];
            }
        }

        // TODO: remove initShopperAccount (and most functions in this service) after migration to new carts
        function initShopperAccount(cart) {
            return getAllShopperData().then(({ shopperAccount, shippingAddresses, paymentMethods }) => {
                const hasSavedShippingAddress = shippingAddresses && shippingAddresses.items.length > 0;

                // shopper does not have shipping address on cart, but they have a saved address. Apply it to cart
                if (hasSavedShippingAddress && !cart.shippingAddress) {
                    const defaultShippingAddress = getDefaultShippingAddress(shippingAddresses);
                    return defaultShippingAddress ?
                        applyAccountInfoToCart(shopperAccount, defaultShippingAddress)
                            .then(updatedCart => ({ updatedCart, shopperAccount, shippingAddresses, paymentMethods }))
                        : { shopperAccount, shippingAddresses, paymentMethods };
                }

                if (!cart.contactInfo || (cart.contactInfo && cart.contactInfo.email !== shopperAccount.emailAddress)) {
                    return applyContactInfoToCart(shopperAccount)
                        .then(updatedCart => ({ updatedCart, shopperAccount, shippingAddresses, paymentMethods }));
                }

                return $q.resolve({ shopperAccount, shippingAddresses, paymentMethods });
            });
        }

        return {
            applyAccountInfoToCart,
            applyShippingAddressToCart,
            applyContactInfoToCart,
            applyShippingAddressToCartLogic,
            applyContactInfoToCartLogic,
            getAllShopperData,
            getDefaultShippingAddress,
            initShopperAccount
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/shopperAccount.service.js